import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DynamicContentLinkHandlerDirective,
  SafeCheckPipe,
} from '@boels/helpers';
import { CmsComponentData, Paragraph } from '@boels/models';
import { PrepareHtmlPipe } from '@boels/shared-state';

@Component({
  selector: 'boels-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.scss'],
  imports: [
    CommonModule,
    DynamicContentLinkHandlerDirective,
    SafeCheckPipe,
    PrepareHtmlPipe,
  ],
})
export class ParagraphComponent {
  @Input() componentData: CmsComponentData<Paragraph>;
}
